module.exports = __webpack_public_path__ + "static/media/informationBar.42840996.svg";